import React from "react";

const Table = (props) => {
  const tableData = props.tableData;
  let columns = [];
  let rows = [];
  tableData.columns.map((colName) => {
    columns.push(<th>{colName}</th>);
  });
  tableData.rows.map((row) => {
    let cells = [];
    row.map((colData, i) => {
      if (i === 0) {
        cells.push(
          <td style={{ textAlign: "left", fontSize: 18 }}>{colData}</td>
        );
      } else
        cells.push(
          <td style={{ textAlign: "center", fontSize: 18 }}>{colData}</td>
        );
    });
    rows.push(<tr>{cells}</tr>);
  });

  return (
    <table className={props.tableClass ? props.tableClass : null}>
      <thead>
        <tr>{columns}</tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  );
};

export default Table;
